import { combineReducers } from 'redux'

import { makeCommunicationReducer } from 'shared/utils/communication/reducer/makeCommunicationReducer'
import { IBetbyState } from '../types'

import * as actions from '../actions'

export default combineReducers<IBetbyState['communications']>({
  getBetbySportToken: makeCommunicationReducer(actions.getBetbySportToken),
})
